import React from 'react';
import Login from "../../components/Login/Login";
import Register from "../../components/Register/Register";
import Title from "../../components/Title/Title";
import Copyright from "../../components/Copyright/Copyright";
import {Box, Grid, IconButton, Paper, Stack, Step, StepLabel, Stepper, Toolbar, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import LanguageButton from "../../components/LanguageButton/LanguageButton";
import ThemeButton from "../../components/ThemeButton/ThemeButton";
import {Link, useHistory, useLocation} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    image: {
        backgroundImage: "url(/assets/archives-departementales.jpg)",
        backgroundRepeat: 'no-repeat',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    link: {
        textDecoration: "none",
        color: theme.palette.text.primary,
    },
}));

export default function LoginPortal() {
    const classes = useStyles();
    const {t} = useTranslation('common');
    const history = useHistory();
    const location = useLocation();
    const [activeStep, setActiveStep] = React.useState(1);
    const [skipped] = React.useState(new Set());
    const [steps, setSteps] = React.useState([t('main.components.auth.register'), t('main.components.auth.login')]);

    React.useEffect(() => {
        document.title = t("main.title") + " - " + t("main.pages.auth.title");
        setSteps([t('main.components.auth.register'), t('main.components.auth.login')]);
    }, [t]);

    React.useEffect(() => {
        const query = new URLSearchParams(location.search);
        const queryActiveStep = query.get("selected");
        if (queryActiveStep) {
            if (queryActiveStep === "register")
                setActiveStep(0);
            else
                setActiveStep(1);
        }
    }, [location.search]);

    const isStepOptional = (step) => {
        return step === 0;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const goToLogin = () => {
        history.replace(location.pathname + "?selected=login");
        setActiveStep(1);
    };

    const goToRegister = () => {
        history.replace(location.pathname + "?selected=register");
        setActiveStep(0);
    };

    const handleLoginSuccess = () => {
        setTimeout(history.goBack, 1000);
    }

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return <Register onClickLogin={goToLogin}/>;
            default:
                return <Login onSuccess={handleLoginSuccess} onClickRegister={goToRegister}/>;
        }
    }

    return (
        <Grid container>
            <Grid item xs={false} sm={4} md={7} className={classes.image}/>
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6}>
                <Stack p={2} display="flex" direction="column" height="100vh">
                    <Toolbar>
                        <IconButton onClick={() => {
                            history.goBack();
                        }}>
                            <Typography color="textPrimary"><ArrowBackIcon/></Typography>
                        </IconButton>
                        <Box flexGrow={1}/>
                        <Stack m={1} spacing={1} direction="row">
                            <LanguageButton/>
                            <ThemeButton/>
                        </Stack>
                    </Toolbar>
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <Link to="/" className={classes.link}>
                            <Title title={t('main.title')} textAlign={'center'}/>
                        </Link>
                    </Box>
                    <Box mt={8} mb={3} flexGrow={1} display="flex" alignItems="center" justifyContent="center">
                        {getStepContent(activeStep)}
                    </Box>
                    <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};
                            if (isStepOptional(index)) {
                                labelProps.optional =
                                    <Typography variant="caption">{t('main.components.auth.optional')}</Typography>;
                            }
                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                    <Box mt={5} mb={2}>
                        <Copyright/>
                    </Box>
                </Stack>
            </Grid>
        </Grid>
    );
}
